module.exports = __webpack_public_path__ + "img/1.6eee795c.jpg";